export enum CommentTypeEnum {
    /**Пользовательский */
    user = 1,
    /**Системный Obsolete Используйте CommentKind.System*/
    system = 2,
    /**Cмена состояния заявки */
    requestChangeStatus = 3
}